import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.472 7.287a2.75 2.75 0 0 0 4.174-1.537H21a.75.75 0 1 0 0-1.5h-2.354a2.75 2.75 0 0 0-5.292 0H3a.75.75 0 0 0 0 1.5h10.354q.044.153.105.302c.209.503.56.932 1.013 1.235M17.25 5a1.25 1.25 0 1 0 0 .001zM10.646 12.75H21a.75.75 0 1 0 0-1.5H10.646a2.751 2.751 0 0 0-5.292 0H3a.75.75 0 1 0 0 1.5h2.354a2.75 2.75 0 0 0 2.646 2 2.75 2.75 0 0 0 2.646-2M9.25 12A1.25 1.25 0 1 1 6.75 12a1.25 1.25 0 0 1 2.5.002M18.646 19.75H21a.75.75 0 1 0 0-1.5h-2.354a2.748 2.748 0 0 0-4.59-1.195 2.75 2.75 0 0 0-.702 1.195H3a.75.75 0 1 0 0 1.5h10.354q.044.153.105.302a2.75 2.75 0 0 0 5.187-.302M17.25 19a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }